import { PWA_CONFIG } from '../config/pwa.config';

export const registerServiceWorker = async (website = PWA_CONFIG.COMPANY_WEBSITE) => {
  const isLocalhost = ['localhost', '127.0.0.1'].includes(window.location.hostname);
  const isSecure = window.location.protocol === 'https:';

  if (!isLocalhost && !isSecure) {
    console.warn('⚠️ Service Workers require HTTPS in production');
    return null;
  }

  if (!('serviceWorker' in navigator)) {
    console.warn('⚠️ Service Workers are not supported in this browser');
    return null;
  }

  try {
    // Use local proxy to avoid cross-origin issues
    const swUrl = `/pwa/service-worker.js?website=${website}`;
    
    // Check if service worker endpoint exists before registering
    const checkResponse = await fetch(swUrl, { method: 'HEAD' }).catch((err) => {
      console.warn('⚠️ Service Worker HEAD request failed:', err.message);
      return null;
    });
    
    if (!checkResponse || !checkResponse.ok) {
      console.warn('⚠️ Service Worker endpoint not available (status:', checkResponse?.status || 'failed', '), skipping registration');
      return null;
    }
    
    const registration = await navigator.serviceWorker.register(swUrl, { scope: '/' });

    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing;
        if (newWorker) {
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            if (window.confirm('New version available! Reload to update?')) window.location.reload();
          }
        });
      }
    });

    setInterval(() => registration.update(), 60 * 60 * 1000);
    return registration;
  } catch (error) {
    console.error('❌ Service Worker registration failed:', error);
    return null;
  }
};

export const unregisterServiceWorker = async () => {
  if (!('serviceWorker' in navigator)) return false;
  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) await registration.unregister();
    return true;
  } catch (error) {
    console.error('❌ Service Worker unregistration failed:', error);
    return false;
  }
};

export const updateServiceWorker = async () => {
  if (!('serviceWorker' in navigator)) return false;
  try {
    const registration = await navigator.serviceWorker.getRegistration();
      if (registration) {
      await registration.update();
      return true;
    }
    return false;
  } catch (error) {
    console.error('❌ Service Worker update failed:', error);
    return false;
  }
};

export default { registerServiceWorker, unregisterServiceWorker, updateServiceWorker };
